import { render, staticRenderFns } from "./SpaceInviteDialog.vue?vue&type=template&id=c73741d6&scoped=true&"
import script from "./SpaceInviteDialog.vue?vue&type=script&lang=js&"
export * from "./SpaceInviteDialog.vue?vue&type=script&lang=js&"
import style0 from "./SpaceInviteDialog.vue?vue&type=style&index=0&id=c73741d6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c73741d6",
  null
  
)

export default component.exports